/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function ConstructionYearField (props: FormNumberFieldProps) {
  const { name = 'constructionYear', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'constructionYear',
        defaultMessage: 'Année de construction'
      })}
      min={1000}
      name={name}
      parser={parseNumber}
      {...others}
    />
  )
}

export default ConstructionYearField
